module.exports = __webpack_public_path__ + "assets/img/newsbj.b8a45201.png";